// extracted by mini-css-extract-plugin
export default {"inlineAdWrapper":"_P-z","inlineTitle":"aQ-z","sponsoredAdsWrapper":"bQ-z","marketplaceRecosWrapper":"cQ-z"};